import { SIZE_TYPE } from '../renderMixin'

export default {
  singlePage: false,
  color: '#909399',
  lineColor: '#303133',
  linePadding: 20,
  fontSize: '16px',
  page: {
    layout: {
      topPadding: 60,
      horizontalPadding: 20
    },
    title: {
      sameWithMenuLabel: false,
      text: null
    },
    background: {
      image: null
    },
    menu: {
      isActive: true,
      list: [
        // {
        //   label: {
        //     html: null,
        //     text: '首页',
        //     color: '#909399',
        //     lineColor: '#303133'
        //   },
        //   link: {
        //     isActive: false,
        //     url: null,
        //     isInnerPage: true,
        //     openInNewWindow: false
        //   },
        //   title: {
        //     sameWithMenuLabel: false,
        //     useParent: true,
        //     text: '欢迎'
        //   },
        //   background: {
        //     useParent: true,
        //     image: 'https://www.ajinga.com/static/xxx.png'
        //   },
        //   menu: {
        //     isActive: false,
        //     layout: {
        //       useParent: true
        //     }
        //   },
        //   bottomBtn: {
        //     isActive: true,
        //     useParent: true
        //   }
        // }
      ]
    },
    bottomLeftBtn: {
      label: null,
      show: false,
      link: {
        url: null,
        isInnerPage: true,
        openInNewWindow: false
      }
    },
    bottomRightBtn: {
      label: null,
      show: false,
      link: {
        url: null,
        isInnerPage: true,
        openInNewWindow: false
      }
    },
    bottomBtn: {
      isActive: true,
      layout: {},
      list: [
        // {
        //   label: {
        //     html: null,
        //     text: 'qwe',
        //     color: '#909399',
        //     lineColor: '#303133'
        //   }
        // }
      ]
    }
  },
  size: {
    width: {
      type: null,
      fixed: null,
      percentage: null
    },
    height: {
      type: SIZE_TYPE.AUTO,
      fixed: null,
      percentage: null
    }
  }
}
